var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-title"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"extra"},[_vm._t("extra")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }